import React, { memo, useLayoutEffect, useRef } from 'react';

import { Factory,  } from "native-base";
import { IconTheme } from './theme';
import { StyleSheet } from 'react-native';

export const SvgIcon = memo(
    Factory(
        ({svg, ...props}: {svg: string} & JSX.IntrinsicElements['svg']) => {
            const ref = useRef<SVGSVGElement | null>(null);


            useLayoutEffect(() => {
                if (!ref.current) return;
                if (!svg) return;
                const div = document.createElement("div");
                div.innerHTML = svg;

                const svgNode = div.querySelector("svg");

                ref.current.innerHTML = ''; // Clear previous content

                ref.current.innerHTML = svgNode.innerHTML;
                
                Object.values(ref.current.attributes).forEach((attribute) => {
                    if (attribute.name === 'style') return;
                    ref.current.attributes.removeNamedItem(attribute.name);
                });

                Object.values(svgNode.attributes).forEach((attribute) => {
                    if (attribute.name === 'style') return;
                    ref.current.setAttribute(attribute.name, attribute.value);
                });


                if (!svgNode.getAttribute("fill")) {
                    ref.current.setAttribute("fill", "currentColor");
                }
                

                if (!ref.current.getAttribute('viewBox')) {
                    ref.current.setAttribute("viewBox", `0 0 ${svgNode.getAttribute("width")} ${svgNode.getAttribute("height")}`);
                }

                div.innerHTML = ''
            }, [svg]);

            const style = React.useMemo(() => props.style ? StyleSheet.flatten([props.style]) : undefined, [props.style]);

            if (!svg) return null;

            return <svg {...props} ref={ref} style={style} />
        },
        IconTheme
    ),
)